import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		list: {
			config: {
				sorting: true,
				fields: {
					author: {},
					email: {
						config: {
							sorting: '"mailing"."email"'
						}
					},
					subject: {},
					message: {
						config: {
							visible: false
						}
					},
					sent: {
						config: {
							sorting: '"mailing"."sent"'
						}
					},
					created_at: {
						config: {
							sorting: '"mailing"."created_at"'
						}
					}
				}
			},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		edit: {
			panel: {
				width: '70%'
			},
			config: {
				fields: {
					author: {},
					email: {},
					subject: {},
					message: {},
					files: {
						fields: {
							name: {},
							storever: {},
							size: {},
							description: {},
							author: {},
							created_at: {}
						}
					}
				}
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}